module.exports = __webpack_public_path__ + "img/groupe-etudiants.efea6cc9.jpg";